import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/common/Button/Button';

/**
 * Login Button Component
 * Navigates to login route with modal query param
 * Uses Button component with primary gradient style
 */
const LoginButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/login?modalType=auth-signin');
  };

  return (
    <Button 
      variant="secondary"
      size="sm"
      onClick={handleClick}
    >
      Sign in
    </Button>
  );
};

export default LoginButton;
